module.exports = __webpack_public_path__ + "img/24.f4dbabaa.png";